<p-table [value]="validEntriesWrappers" [class.dynamic-size-table]="true">
  <ng-template pTemplate="header">
    <tr>
      <th>#</th>
      <th *ngFor="let col of columns">{{ col.header }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr>
      <td>{{ item.lineNumber - 1 }}</td>
      <td *ngFor="let col of columns">{{ col.value }}</td>
    </tr>
  </ng-template>
</p-table>

<!--- DATATABLE DEPRECATED
<p-dataTabl [value]="validEntriesWrappers" [immutable]="false" [class.dynamic-size-table]="true">
    <p-column field="lineNumber" header="#"></p-column>
    <p-column *ngFor="let col of columns" [header]="col.header" [field]="col.field"></p-column>
</p-dataTable>
--->

<p-confirmDialog
  header="Confirmation"
  icon="fa ui-icon-question"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
